{
  "title": "",
  "subtitle": "",
  "field": {
    "email": "",
    "password": "",
    "old_password": "รหัสผ่านปัจจุบัน",
    "new_password": "รหัสผ่านใหม่",
    "confirm_password": "ยืนยันรหัสผ่านใหม่"
  },
  "placeholder": {
    "email": ""
  },
  "action": {
    "sign_in": "",
    "keep_signed_in": "",
    "need_help": "",
    "logout": "ออกจากระบบ",
    "change_password": "เปลี่ยนรหัสผ่าน"
  },
  "header": {
    "signed_in_as": "เข้าสู่ระบบในชื่อ"
  },
  "error": {
    "invalid": "",
    "lockout": "",
    "old_password_invalid": "รหัสผ่านปัจจุบันไม่ถูกต้อง"
  },
  "security_notice": "",
  "change_password": {
    "title": "เปลี่ยนรหัสผ่านของคุณ",
    "subtitle": "เลือกรหัสผ่านใหม่ ระบบจะออกจากระบบในอุปกรณ์อื่นทั้งหมด",
    "success": "เปลี่ยนรหัสผ่านสำเร็จ กรุณาเข้าสู่ระบบอีกครั้ง"
  }
}
